import React from 'react';
import { Box, Typography } from '@ublend-npm/aulaui-core';
import { useDispatch, useSelector } from 'react-redux';
import { toggleWidgetPreference } from '../../../../../actions/home/widgetPreferences';
import { WidgetPreference } from '@core/types/state';
import Switch from '@app/components/presentational/common/Switch';
import widgetsLibrary from '../../widgetsLibrary';

const ManageWidget = () => {
  const dispatch = useDispatch();

  const widgetPreferences: WidgetPreference[] | null = useSelector(
    (state: any) => state.home?.widgetPreferences
  );
  const [loadingKey, setLoadingKey] = React.useState<string | null>(null);

  const handleToggle = async (widgetId: string, currentIsHidden: boolean) => {
    setLoadingKey(widgetId);
    await (dispatch as any)(toggleWidgetPreference(widgetId, !currentIsHidden));
    setLoadingKey(null);
  };

  const widgetEntries = widgetsLibrary
    .filter((w) => w.id !== 'widget-009')
    .reduce((acc, widget) => {
      acc[widget.id] = widget;
      return acc;
    }, {} as Record<string, any>);

  return (
    <Box
      bgcolor="white"
      borderRadius="16px"
      boxShadow="0 4px 16px rgba(0, 0, 0, 0.04)"
      p="24px"
    >
      <Typography fontWeight="medium" color="primary" mb={4}>
        Manage widgets
      </Typography>

      {Object.entries(widgetEntries).map(
        ([widgetId, widgetInfo]: any, index) => {
          const widgetPref = widgetPreferences?.find(
            (w) => w.widgetId === widgetId
          );
          const isLast = index === Object.keys(widgetEntries).length - 1;

          return (
            <Box
              key={widgetId}
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              pb={3}
              mb={isLast ? 0 : 3}
              borderBottom={isLast ? 'none' : '1px solid #eaeaea'}
            >
              <Box display="flex" alignItems="center" gap="16px">
                <Box
                  width="52px"
                  height="52px"
                  borderRadius="50%"
                  bgcolor="#5b507a"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  color="white"
                  mb={0}
                  position="relative"
                >
                  {widgetInfo.icon}
                  <Box
                    position="absolute"
                    bottom="-4px"
                    right="-4px"
                    bgcolor="#ff8a00"
                    color="white"
                    fontSize="11px"
                    fontWeight={700}
                    width="20px"
                    height="20px"
                    borderRadius="50%"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    border="2px solid white"
                  >
                    1
                  </Box>
                </Box>
                <Box>
                  <Typography
                    color="#333333"
                    fontWeight={600}
                    fontSize="16px"
                    mb="4px"
                  >
                    {widgetInfo.title}
                  </Typography>
                  <Typography color="#888888" fontSize="13px">
                    Toggle to unhide
                  </Typography>
                </Box>
              </Box>
              <Switch
                checked={widgetPref ? !widgetPref.isHidden : true}
                onChange={() =>
                  handleToggle(
                    widgetId,
                    widgetPref ? widgetPref.isHidden : false
                  )
                }
                disabled={loadingKey === widgetId}
              />
            </Box>
          );
        }
      )}
    </Box>
  );
};

export default ManageWidget;
